import Button from 'components/Button';
import { useAppDispatch, useAppSelector } from 'customer/store/configureStore';
import { SnackbarKey, useSnackbar } from 'notistack';
import { ReactNode, useEffect, useState } from 'react';
import actions from '../actions';

/**
 * @deprecated Use src/components/Notification
 */
const Notifier = () => {
  const dispatch = useAppDispatch();
  const [displayed, setDisplayed] = useState<Array<string>>([]);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const { alerts } = useAppSelector(({ notification }) => ({
    alerts: notification?.alert?.alerts || [],
  }));

  const removeDisplayed = (key: string) => {
    setDisplayed(displayed.filter((k) => k !== key));
  };
  useEffect(() => {
    if (alerts?.length) {
      const d: string[] = [];
      for (let i = 0; i < alerts?.length || 0; i += 1) {
        const { key, message, variant, dismissed = false } = alerts[i];
        if (dismissed) {
          // dismiss snackbar using notistack
          closeSnackbar(key);
        }
        // do nothing if snackbar is already displayed
        else if (!displayed.includes(key)) {
          // display snackbar using notistack
          enqueueSnackbar(message, {
            persist:
              alerts[i]?.variant === 'error' ||
              alerts[i]?.variant === 'warning',
            preventDuplicate: true,
            key,
            variant,
            anchorOrigin: {
              horizontal: 'left',
              vertical: 'bottom',
            },
            style: {
              zIndex: 999999,
              fontWeight: 400,
            },

            action: (k: SnackbarKey): ReactNode => (
              <Button
                small
                icon="close"
                white
                onClick={() => closeSnackbar(k)}
              />
            ),

            onExited: (event, k) => {
              // remove this snackbar from redux store
              if (!k) return;
              const k2 = typeof k === 'string' ? k : k?.toString();
              dispatch(actions.close(k2));
              removeDisplayed(k2);
            },
          });
          d.push(key);
        }
      }
      // keep track of snackbars that we've displayed
      if (d.length > 0) {
        setDisplayed([...displayed, ...d]);
      }
    }
  }, [alerts, closeSnackbar, enqueueSnackbar]);

  return null;
};

export default Notifier;
